import { Injectable } from '@angular/core';
import { ParamMap, Router } from '@angular/router';
import { RolPlataforma } from '../models/novedades.models';
import { ROLE_OPTIONS, routeForRole } from '../utils/roles.util';

@Injectable({
  providedIn: 'root',
})
export class RoleContextService {
  readonly roles = ROLE_OPTIONS;

  resolveRole(paramMap: ParamMap, fallbackRole: RolPlataforma): RolPlataforma {
    const rawRole = paramMap.get('role');
    return this.isValidRole(rawRole) ? rawRole : fallbackRole;
  }

  isValidRole(role: string | null | undefined): role is RolPlataforma {
    return !!role && this.roles.some((item) => item.key === role);
  }

  getRoleLabel(role: RolPlataforma): string {
    return this.roles.find((item) => item.key === role)?.label ?? 'Usuario';
  }

  navigateToRole(router: Router, role: RolPlataforma): Promise<boolean> {
    return router.navigate([routeForRole(role)], { queryParams: { role } });
  }
}
